module.exports = __webpack_public_path__ + "img/37.689c208e.png";